import { isWeb } from '../../src/utils/platformUtils'
import { getRealDatabase } from '../../database-sqlite/DatabaseSingleton'
import { TABLE_NAME } from '../constants/tables'
import { getDb } from '../../db-sqlite/adapter'

/**
 * @description // Guarda o limpia el attempt_id activo en la evaluación (para recuperarlo si la app se reinicia)
// Pasar null para limpiar (evaluación completada o reintento iniciado)
 * @param evaluation_id 
 * @param attempt_id 
 */
export const update_evaluation_current_attempt_id = async (
    evaluation_id,
    attempt_id,
) => {
    try {
        const db = await getDb()

        const updateSql = `UPDATE ${TABLE_NAME.LEARNING_EVALUATIONS} SET current_attempt_id = ? WHERE _id = ?;`
        const updateParams = [attempt_id ?? null, evaluation_id]

        await db.run({ sql: updateSql, params: updateParams })
    } catch (error) {
        console.error('Error in update_evaluation_current_attempt_id:', error)
        throw error
    }
}

/**
 * @description Actualiza partial_anmswers en la BD local para saber dónde quedó el usuario (funciona offline)
 * @param evaluation_id
 * @param partial_anmswers
 */
export const update_evaluation_partial_answers = async (
    evaluation_id,
    partial_anmswers,
) => {
    try {
        const db = await getDb()

        const updateSql = `UPDATE ${TABLE_NAME.LEARNING_EVALUATIONS} SET partial_anmswers = ? WHERE _id = ?;`
        const updateParams = [JSON.stringify(partial_anmswers), evaluation_id]

        await db.run({ sql: updateSql, params: updateParams })
    } catch (error) {
        console.error('Error in update_evaluation_partial_answers:', error)
        throw error
    }
}

export const update_evaluation_attempt_date_created = async (
    evaluation_id,
    attempt_date_created,
) => {
    try {
        const db = await getDb()
        const updateSql = `UPDATE ${TABLE_NAME.LEARNING_EVALUATIONS} SET attempt_date_created = ? WHERE _id = ?;`
        await db.run({ sql: updateSql, params: [attempt_date_created ?? null, evaluation_id] })
    } catch (error) {
        console.error('Error in update_evaluation_attempt_date_created:', error)
        throw error
    }
}

/**
 * @description Marca un assessment como enviado (status = 1) en vez de borrarlo, para que los reintentos puedan recuperar las respuestas anteriores
 * @param assessmentId
 */
export const mark_assessment_as_sent = async (assessmentId) => {
    try {
        if (isWeb()) return // Solo para SQLite, en web se borra directamente
        const db = await getDb()

        const updateSql = `UPDATE ${TABLE_NAME.LEARNING_ANSWERS_EVALUATIONS} SET status = 1 WHERE _id = ?;`
        const updateParams = [assessmentId]

        await db.run({ sql: updateSql, params: updateParams })
    } catch (error) {
        console.error('Error marking assessment as sent:', error)
        throw error
    }
}

export const update_status_local_course = async (
    courseId,
    newStatus,
    assessmentResult,
) => {
    try {
        const db = await getDb()

        const updateSql = assessmentResult !== null && assessmentResult !== undefined
            ? `UPDATE ${TABLE_NAME.LEARNING_COURSES} SET status = ?, assessmentResult = ? WHERE _id = ?;`
            : `UPDATE ${TABLE_NAME.LEARNING_COURSES} SET status = ? WHERE _id = ?;`
        const updateParams = assessmentResult !== null && assessmentResult !== undefined
            ? [newStatus, assessmentResult, courseId]
            : [newStatus, courseId]

        await db.run({ sql: updateSql, params: updateParams })
    } catch (error) {
        console.error('Error in update_status_local_course:', error)
        throw error
    }
}
